const preventEventPropagation = target => {
    target.stopImmediatePropagation();
    target.stopPropagation();
    target.preventDefault();
}

document.querySelector('nav button').addEventListener('pointerdown', clicked => {
    clicked.stopImmediatePropagation();
    clicked.currentTarget.setAttribute('aria-pressed', clicked.currentTarget.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
});
document.querySelectorAll('li.parent > a > scale-icon-navigation-right').forEach(icon => {
    const toggleMenuItem = ['keyup', 'click', 'pointerup'];

    icon.addEventListener('pointerdown', evt => {
        preventEventPropagation(evt)
        const item = icon.closest('li');
        item.setAttribute('aria-checked', item.getAttribute('aria-checked') === 'false' ? 'true' : 'false');
    });
    toggleMenuItem.forEach(event => {
        icon.addEventListener(event, preventEventPropagation)
    })
});
